<app-icon-button
  class="rounded-md"
  placement="top-right"
  [svgIconPath]="'remove'"
  [type]="'basic'"
  [disabled]="isDisabled"
  ngbTooltip="{{ !isDisabled && 'commenting.deleteAllBtn' | translate }}"
  (click)="deleteAll()"
>
</app-icon-button>
